import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import MeasuredTorpedo from '../MeasuredTorpedo';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import MediaService from '../../utils/DeviationMediaService';
export const itemRenderer = (renderProps, item, itemStyle)=>{
    return /*#__PURE__*/ React.createElement(StandardThumb, {
        key: `item-${item.idx}`,
        deviation: item.dto.deviation,
        width: item.width,
        height: item.height,
        style: itemStyle
    });
};
const DeviationTorpedo = (_param)=>{
    var { items: itemsFromProps } = _param, torpedoProps = _object_without_properties(_param, [
        "items"
    ]);
    const items = itemsFromProps.map((item)=>{
        const largest = MediaService.getThumbDimensions(item);
        return {
            id: `deviation-${item.deviationId}`,
            width: largest.width,
            height: largest.height,
            deviation: item,
            duperbrowseItemId: getDeviationEntityId(item)
        };
    });
    return /*#__PURE__*/ React.createElement(MeasuredTorpedo, _object_spread({
        items: items,
        renderItem: itemRenderer
    }, torpedoProps));
};
DeviationTorpedo.displayName = 'DeviationTorpedo';
export default DeviationTorpedo;

//# sourceMappingURL=DeviationTorpedo.js.map